import { InputMasks } from 'common/fields/input-field';
import * as Yup from 'yup';

export const model = {
  email: {
    label: '',
    type: 'text',
    name: 'email',
    withBorder: false,
    placeholder: 'Email address ...',
    mask: InputMasks.email,
  },
};

export const validationSchema = () =>
  Yup.object().shape({
    [model.email.name]: Yup.string()
      .required()
      .email('Invalid E-Mail format' as string),
  });

export const initialValues = {
  [model.email.name]: '',
};
